import TextField from "common/DS/IndeterminateTextField";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

export const CounterTextarea = ({
    onChange,
    helperText,
    maxChars,
    focusFront,
    autoFocus,
    helperTextStyle,
    errorText,
    errorTextStyle,
    error,
    showCounter,
    ...props
}) => {
    const [initVal] = useState(props.defaultValue || props.value);
    const [textLen, setTextLen] = useState(initVal?.length || 0);
    const inputRef = useRef();

    useEffect(() => {
        inputRef.current?.focus();
    }, [inputRef.current]);

    const setTextInputRef = (element) => {
        inputRef.current = element;
    };

    return (
        <TextField
            multiline
            fullWidth
            error={error}
            {...props}
            inputRef={autoFocus ? setTextInputRef : null}
            onFocus={(e) => {
                if (focusFront && e.target.value === initVal) {
                    e.target.setSelectionRange(0, 0);
                }
            }}
            onChange={(e) => {
                setTextLen(e.target.value.length);
                onChange(e);
            }}
            helperText={
                showCounter && (
                    <span className="flex flex-jsb">
                        {error && <span style={errorTextStyle}>{errorText}</span>}
                        <span style={{ marginRight: "32px" }}>{helperText}</span>
                        {(textLen > 0 || maxChars > 0) && (
                            <span style={helperTextStyle} className="text-nowrap">
                                {textLen}
                                {maxChars > 0 && `/${maxChars}`}
                            </span>
                        )}
                    </span>
                )
            }
        />
    );
};
CounterTextarea.propTypes = {
    onChange: PropTypes.func,
    helperText: PropTypes.node,
    maxChars: PropTypes.number,
    focusFront: PropTypes.bool,
    autoFocus: PropTypes.bool,
    helperTextStyle: PropTypes.object,
    errorText: PropTypes.string,
    errorTextStyle: PropTypes.object,
    showCounter: PropTypes.bool,
    ...TextField.propTypes,
};
CounterTextarea.defaultProps = {
    onChange: () => {},
    helperText: null,
    helperTextStyle: { width: "40px" },
    maxChars: 1000,
    focusFront: false,
    autoFocus: false,
    errorText: null,
    errorTextStyle: { marginLeft: "16px" },
    showCounter: true,
    ...TextField.defaultProps,
};
